<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='"  display: flex;\n  justify-content: center;\n  background-color: #f0f0f0;\npadding-bottom:80px;\n"' class="rcontainer" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='" width: 480px; \/* \u0639\u0631\u0636 \u06a9\u0627\u0646\u062a\u06cc\u0646\u0631 \u0645\u062e\u0635\u0648\u0635 \u0645\u0648\u0628\u0627\u06cc\u0644 *\/\nheight:100%;\n\n\n\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n"' class="inner-container bg-white" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="row mx-auto p-0 justify-content-center text-center product-container relative px-2 shadow" >
                <template #default>   <m-single-product-201 v-bind='{...{"productLink":null,"relatedProducts":true,"productCardName":"mProductCard207_price","relatedCourse":false,"galleryFullSlider":false,"productAuthor":false},...{}}' :style='""' class="my-3 container " >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div></template>
                </m-single-product-201></template>
                </m-div></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mSingleProduct201 from '@moeinmdn/miw-alpha-components/src/package/Product/Single/SingleProduct201';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mSingleProduct201 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
